import { IBrandingOverrides, ITenantID } from './types';

// Here instead of in env, as it will make sure you are changing it intentionally
const brandingVersion = '1.2.0';

export const getBrandingOverrides = async (
  tenantId: ITenantID | null
): Promise<IBrandingOverrides[]> => {
  if (!tenantId) {
    return [];
  }

  const modules = import.meta.glob<IBrandingOverrides>(
    './BrandingOverrides/*.json',
    { eager: true }
  );

  const tenantOverrides = Object.values(modules).filter(
    (resource) => resource.tenantGUID === tenantId
  );

  const hasWrongVersion = tenantOverrides.some(
    (resource) => resource.version !== brandingVersion
  );
  if (hasWrongVersion) {
    throw new Error(
      'incorrect version for theme, expecting version ' + brandingVersion
    );
  }

  return tenantOverrides;
};
